import { render, staticRenderFns } from "./NewDetail.vue?vue&type=template&id=8845841a&scoped=true&"
import script from "./NewDetail.vue?vue&type=script&lang=js&"
export * from "./NewDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewDetail.vue?vue&type=style&index=0&id=8845841a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8845841a",
  null
  
)

export default component.exports